import React from "react";
import ExplorePage from "./v2/pages/ExplorePage";
import {
  SiteFooter,
  TrustDocumentPage,
  useTrustNavigation,
} from "./v2/trust";
import "./v2/styles/v2.css";

/**
 * App shell: Explore map + modular trust pages (hash routes).
 * Trust UI lives under src/v2/trust so it stays easy to debug.
 */
export default function App() {
  const { pageId, isExplore, navigate, goExplore } = useTrustNavigation();

  if (!isExplore) {
    return (
      <div className="v2-app v2-app--trust">
        <div className="v2-app-main">
          <TrustDocumentPage
            pageId={pageId}
            onBack={goExplore}
            onNavigate={navigate}
          />
        </div>
        <SiteFooter compact onNavigate={navigate} />
      </div>
    );
  }

  return (
    <div className="v2-app v2-app--explore">
      <div className="v2-app-main">
        <ExplorePage onNavigateTrust={navigate} />
      </div>
      <SiteFooter onNavigate={navigate} />
    </div>
  );
}
